import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const AuditProLayout = lazy(() =>
  import('../components/audit-pro/AuditProLayout').then((m) => ({ default: m.AuditProLayout }))
)
const AuditProHubPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.HubPage }))
)
const AuditProCockpitPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CockpitPage }))
)
const AuditProCalendarPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CalendarPage }))
)
const AuditProScorePage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ScorePage }))
)
const AuditProUniversePage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.UniversePage }))
)
const AuditProAnnualPlanPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.AnnualPlanPage }))
)
const AuditProPlanWizardPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.PlanWizardPage }))
)
const AuditProResourcesPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ResourcesPage }))
)
const AuditProMissionsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.MissionsPage }))
)
const AuditProMissionDetailPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.MissionDetailPage }))
)
const AuditProWorkpapersPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.WorkpapersPage }))
)
const AuditProChecklistsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ChecklistsPage }))
)
const AuditProEvidencePage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.EvidencePage }))
)
const AuditProFindingsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.FindingsPage }))
)
const AuditProFindingDetailPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.FindingDetailPage }))
)
const AuditProActionsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ActionsPage }))
)
const AuditProActionDetailPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ActionDetailPage }))
)
const AuditProRecommendationsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.RecommendationsPage }))
)
const AuditProTrackingPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.TrackingPage }))
)
const AuditProCertDashboardPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertDashboardPage }))
)
const AuditProCertReadinessPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertReadinessPage }))
)
const AuditProCertGapPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertGapPage }))
)
const AuditProCertTimelinePage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertTimelinePage }))
)
const AuditProCertControlsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertControlsPage }))
)
const AuditProReportAuditPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ReportAuditPage }))
)
const AuditProCommitteePage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CommitteePage }))
)
const AuditProSelfAssessPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.SelfAssessPage }))
)
const AuditProAuditTrailPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.AuditTrailPage }))
)
const AuditProTemplatesPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.TemplatesPage }))
)
const AuditProIntegrationPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.AuditProIntegrationPage }))
)
const AuditProSettingsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.SettingsPage }))
)
const AuditProOutilsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.AuditProOutilsPage }))
)
const AuditProMethodologyPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.MethodologyPage }))
)
const AuditProEngagementPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.EngagementPage }))
)
const AuditProFieldworkPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.FieldworkPage }))
)
const AuditProInterviewsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.InterviewsPage }))
)
const AuditProClientPortalPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ClientPortalPage }))
)
const AuditProQualityReviewPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.QualityReviewPage }))
)
const AuditProControlTestingPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ControlTestingPage }))
)
const AuditProControlSelfAssessmentPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ControlSelfAssessmentPage }))
)
const AuditProITGCPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ITGCPage }))
)
const AuditProContinuousAuditPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ContinuousAuditPage }))
)
const AuditProAuditReadinessPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.AuditReadinessPage }))
)
const AuditProAuditorPortalPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.AuditorPortalPage }))
)
const AuditProCertProjectsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertProjectsPage }))
)
const AuditProCertProjectWizardPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertProjectWizardPage }))
)
const AuditProCertDecisionPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertDecisionPage }))
)
const AuditProCertSurveillancePage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertSurveillancePage }))
)
const AuditProCertBodyRegistryPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertBodyRegistryPage }))
)
const AuditProCertBodyPortalPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertBodyPortalPage }))
)
const AuditProCertEvidenceRequestsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertEvidenceRequestsPage }))
)
const AuditProCertAuditWorkspacePage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertAuditWorkspacePage }))
)
const AuditProCertDocRequirementsPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertDocRequirementsPage }))
)
const AuditProControlPredictionPage = lazy(() =>
  import('../pages/audit-pro/ControlPredictionPage').then((m) => ({ default: m.ControlPredictionPage }))
)
const AuditProEvidenceVerificationPage = lazy(() =>
  import('../pages/audit-pro/EvidenceVerificationPage').then((m) => ({ default: m.EvidenceVerificationPage }))
)
const AuditProCertScopeAdjustPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertScopeAdjustPage }))
)
const AuditProCertNonconformitiesPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.CertNonconformitiesPage }))
)
const AuditProExternalAuditSupportPage = lazy(() =>
  import('../pages/audit-pro').then((m) => ({ default: m.ExternalAuditSupportPage }))
)

export const auditProRoutes: RouteObject[] = [
  {
    path: '/audit-pro',
    element: <AuditProLayout />,
    children: [
      { index: true, element: <AuditProHubPage /> },

      { path: 'hub', element: <AuditProHubPage /> },
      { path: 'cockpit', element: <AuditProCockpitPage /> },
      { path: 'calendar', element: <AuditProCalendarPage /> },
      { path: 'score', element: <AuditProScorePage /> },
      { path: 'universe', element: <AuditProUniversePage /> },
      { path: 'annual-plan', element: <AuditProAnnualPlanPage /> },
      { path: 'plan-wizard', element: <AuditProPlanWizardPage /> },
      { path: 'resources', element: <AuditProResourcesPage /> },
      { path: 'missions', element: <AuditProMissionsPage /> },
      { path: 'missions/:id', element: <AuditProMissionDetailPage /> },
      { path: 'workpapers', element: <AuditProWorkpapersPage /> },
      { path: 'checklists', element: <AuditProChecklistsPage /> },
      { path: 'evidence', element: <AuditProEvidencePage /> },
      { path: 'findings', element: <AuditProFindingsPage /> },
      { path: 'findings/:id', element: <AuditProFindingDetailPage /> },
      { path: 'actions', element: <AuditProActionsPage /> },
      { path: 'actions/:id', element: <AuditProActionDetailPage /> },
      { path: 'recommendations', element: <AuditProRecommendationsPage /> },
      { path: 'tracking', element: <AuditProTrackingPage /> },
      { path: 'cert-dashboard', element: <AuditProCertDashboardPage /> },
      { path: 'cert-readiness', element: <AuditProCertReadinessPage /> },
      { path: 'cert-gaps', element: <AuditProCertGapPage /> },
      { path: 'cert-timeline', element: <AuditProCertTimelinePage /> },
      { path: 'cert-controls', element: <AuditProCertControlsPage /> },
      { path: 'reports', element: <AuditProReportAuditPage /> },
      // Profile-MD aliases for /report/* fragments (engagement report workflow)
      { path: 'report', element: <AuditProReportAuditPage /> },
      { path: 'report/', element: <AuditProReportAuditPage /> },
      { path: 'report/draft', element: <AuditProReportAuditPage /> },
      { path: 'report/publish', element: <AuditProReportAuditPage /> },
      { path: 'report/quality-review', element: <AuditProReportAuditPage /> },
      { path: 'committee', element: <AuditProCommitteePage /> },
      { path: 'self-assessment', element: <AuditProSelfAssessPage /> },
      { path: 'audit-trail', element: <AuditProAuditTrailPage /> },
      { path: 'templates', element: <AuditProTemplatesPage /> },
      { path: 'integration', element: <AuditProIntegrationPage /> },
      { path: 'settings', element: <AuditProSettingsPage /> },
      { path: 'outils', element: <AuditProOutilsPage /> },
      { path: 'methodology', element: <AuditProMethodologyPage /> },
      { path: 'engagements', element: <AuditProEngagementPage /> },
      { path: 'fieldwork', element: <AuditProFieldworkPage /> },
      { path: 'interviews', element: <AuditProInterviewsPage /> },
      { path: 'client-portal', element: <AuditProClientPortalPage /> },
      { path: 'quality-review', element: <AuditProQualityReviewPage /> },
      { path: 'control-testing', element: <AuditProControlTestingPage /> },
      { path: 'control-self-assessment', element: <AuditProControlSelfAssessmentPage /> },
      { path: 'itgc', element: <AuditProITGCPage /> },
      { path: 'continuous-audit', element: <AuditProContinuousAuditPage /> },
      { path: 'audit-readiness', element: <AuditProAuditReadinessPage /> },
      { path: 'auditor-portal', element: <AuditProAuditorPortalPage /> },
      { path: 'cert-projects', element: <AuditProCertProjectsPage /> },
      { path: 'cert-wizard', element: <AuditProCertProjectWizardPage /> },
      { path: 'cert-decisions', element: <AuditProCertDecisionPage /> },
      { path: 'cert-surveillance', element: <AuditProCertSurveillancePage /> },
      { path: 'cert-bodies', element: <AuditProCertBodyRegistryPage /> },
      { path: 'cert-body-portal', element: <AuditProCertBodyPortalPage /> },
      { path: 'cert-evidence-requests', element: <AuditProCertEvidenceRequestsPage /> },
      { path: 'cert-workspace', element: <AuditProCertAuditWorkspacePage /> },
      { path: 'cert-doc-requirements', element: <AuditProCertDocRequirementsPage /> },
      { path: 'control-prediction', element: <AuditProControlPredictionPage /> },
      { path: 'evidence-verification', element: <AuditProEvidenceVerificationPage /> },
      { path: 'cert-scope-adjust', element: <AuditProCertScopeAdjustPage /> },
      { path: 'cert-nonconformities', element: <AuditProCertNonconformitiesPage /> },
      { path: 'external-audit-support', element: <AuditProExternalAuditSupportPage /> },
    ],
  },
]
